import React, { useContext } from 'react';

import Context from '../Context';
import RedirectToGreet from '../Components/RedirectToGreet';
import { Loading } from '~/App/Modules/Common/Components/Greet/Loading';

export default function GreetRedirect() {
  const { greets } = useContext(Context);

  if (greets.metadata.loading) {
    return <Loading />;
  }

  return <RedirectToGreet />;
}
